// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RepositOfferRecipientDTO
 */
export interface RepositOfferRecipientDTO {
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    repositOfferId: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    choice?: RepositOfferRecipientDTOChoiceEnum;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RepositOfferRecipientDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum RepositOfferRecipientDTOChoiceEnum {
    REPOSIT = 'REPOSIT',
    CASHDEPOSIT = 'CASH_DEPOSIT'
}



